// extracted by mini-css-extract-plugin
export default {"container":"_aa-z","productName":"aba-z","price":"bba-z","dimensions":"cba-z"};